import { LitElement, css, html } from "lit"
import { unsafeHTML } from "lit/directives/unsafe-html.js"
const { apiFetch } = window.wp
import { addQueryArgs } from "@wordpress/url"

const LOADING_SVG = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><style>.spinner_OSmW{transform-origin:center;animation:spinner_T6mA .75s step-end infinite}@keyframes spinner_T6mA{8.3%{transform:rotate(30deg)}16.6%{transform:rotate(60deg)}25%{transform:rotate(90deg)}33.3%{transform:rotate(120deg)}41.6%{transform:rotate(150deg)}50%{transform:rotate(180deg)}58.3%{transform:rotate(210deg)}66.6%{transform:rotate(240deg)}75%{transform:rotate(270deg)}83.3%{transform:rotate(300deg)}91.6%{transform:rotate(330deg)}100%{transform:rotate(360deg)}}</style><g class="spinner_OSmW"><rect x="11" y="1" width="2" height="5" opacity=".14"/><rect x="11" y="1" width="2" height="5" transform="rotate(30 12 12)" opacity=".29"/><rect x="11" y="1" width="2" height="5" transform="rotate(60 12 12)" opacity=".43"/><rect x="11" y="1" width="2" height="5" transform="rotate(90 12 12)" opacity=".57"/><rect x="11" y="1" width="2" height="5" transform="rotate(120 12 12)" opacity=".71"/><rect x="11" y="1" width="2" height="5" transform="rotate(150 12 12)" opacity=".86"/><rect x="11" y="1" width="2" height="5" transform="rotate(180 12 12)"/></g></svg>`

export class CustomShop extends LitElement {
	static properties = {
		filters: { type: Object },
		products: { type: Array },
		taxonomy: { type: String },
		taxid: { type: Number },
		loading: { type: Boolean },
		message: { type: String },
		nonce: { type: String },
		page: { type: Number },
		categories: { type: Array },
		excluded_categories: { type: Array },
		breadcrumbs: { type: Array },
		shopUrl: { type: String },
		categoriesOpen: { type: Boolean },
		description: { type: String },
	}

	constructor() {
		super()
		this.filters = {}
		this.products = []
		this.taxonomy = ""
		this.taxid = null
		this.loading = false
		this.message = ""
		this.nonce = ""
		this.page = 1

		this.description = ""
		this.totalMatching = 0
		this.total_pages = 1
		this.categories = []
		this.excluded_categories = []
		this.breadcrumbs = []
		this.shopUrl = "/produkter/"
		this.categoriesOpen = false
	}

	connectedCallback() {
		super.connectedCallback()
		// Set filters from URL params
		// look for page param in url
		const url = new URL(window.location.href)
		const params = url.searchParams
		if (params.get("page")) {
			this.page = parseInt(params.get("page"))
		}
		this.getCategories()
		this.getFilteredProducts()

		this.addEventListener("filters-changed", async e => {
			this.page = 1
			this.products = await this.getFilteredProducts()
		})

		this.addEventListener("page-changed", async e => {
			if (e.detail && e.detail.page && e.detail.page !== this.page) {
				this.page = e.detail.page
				this.products = await this.getFilteredProducts()
			}
		})
	}

	createRenderRoot() {
		return this
	}

	async getCategories() {
		try {
			let path = `/wc/store/products/categories`
			const query = { per_page: 100, hide_empty: false }
			console.log("this.taxid", this.taxid)
			if (this.taxid) {
				query.parent = this.taxid
			} else {
				query.parent = 0
			}
			let categories = await apiFetch({
				path: addQueryArgs(path, query),
				method: "GET",
				headers: { "X-WP-Nonce": this.nonce },
			})

			if (this.taxid) {
				let currentCat = await apiFetch({
					path: `/wc/store/products/categories/${this.taxid}`,
					method: "GET",
					headers: { "X-WP-Nonce": this.nonce },
				})
				if (currentCat) {
					this.description = currentCat.description || ""
				}
			}

			// order by menu order
			// categories.sort((a, b) => a.menu_order - b.menu_order)

			// filter out categories with zero products
			categories = categories.filter(cat => cat.count > 0)
			// Generate breadcrumbs from taxonomy and taxid
			let breadcrumbs = []
			if (this.taxonomy && this.taxid) {
				let currentCat = categories.find(cat => cat.id === this.taxid)
				if (currentCat) {
					this.description = currentCat.description || ""
				}
				while (currentCat) {
					breadcrumbs.push({
						id: currentCat.id,
						name: currentCat.name,
						permalink: currentCat.permalink,
					})
					currentCat = categories.find(cat => cat.id === currentCat.parent)
				}
			}
			breadcrumbs.push({
				id: 0,
				name: "Produkter",
				permalink: this.shopUrl,
			})
			this.breadcrumbs = breadcrumbs
			this.breadcrumbs.reverse()

			if (this.taxid) {
				this.categories = categories.filter(cat => cat.parent === this.taxid)
			} else {
				this.categories = categories.filter(cat => cat.parent === 0)
			}

			this.excluded_categories = categories.map(cat => cat.id)
			this.categoriesOpen = categories.length < 5
		} catch (err) {
			console.error("Error fetching categories:", err)
		}
	}

	async getFilteredProducts() {
		this.loading = true
		this.message = ""
		const url = new URL(window.location.href)
		const params = url.searchParams

		let q = {}

		if (this.taxonomy && this.taxid) {
			// Normalize taxonomy key to Store API parameter
			const tax = String(this.taxonomy).toLowerCase()
			if (tax === "product_cat" || tax === "category" || tax === "categories") {
				q.category = this.taxid
			} else {
				q[tax] = this.taxid
			}
		}

		// Exclude categories if any are set
		if (this.excluded_categories.length > 0) {
			let unfilteredCategories = this.categories.filter(
				cat => !this.excluded_categories.includes(cat.id),
			)
			const includeIds = unfilteredCategories.map(cat => cat.id)
			if (includeIds.length > 0) {
				q.category = includeIds.join(",")
			}
		}

		if (params) {
			if (params.get("price_min")) {
				q.min_price = params.get("min_price")
			} else {
				q.min_price = 1
			}
			if (params.get("price_max")) {
				q.max_price = params.get("max_price")
			}
			if (params.get("brand")) {
				q.brand = params.get("brand")
			}
			if (params.get("location")) {
				q._unstable_tax_product_location = params.get("location")
			}

			// Parse attributes into structured array
			const attrKeys = [...params.keys()].filter(k =>
				k.startsWith("attributes["),
			)
			if (attrKeys.length > 0) {
				const attrMap = {}
				attrKeys.forEach(k => {
					const match = k.match(/attributes\[(\d+)\]\[(attribute|slug)\]/)
					if (!match) return
					const [_, index, field] = match
					if (!attrMap[index]) attrMap[index] = {}
					attrMap[index][field] = params.get(k)
				})
				q.attributes = Object.values(attrMap)
			}
		}

		if (!q.min_price) {
			q.min_price = 1
		}
		q.page = this.page
		q.stock_status = "instock"
		q.per_page = 12

		try {
			const path = `/wc/store/products`
			const result = await apiFetch({
				path: addQueryArgs(path, q),
				method: "GET",
				headers: { "X-WP-Nonce": this.nonce },
				parse: false,
			})
			this.totalMatching = result.headers.get("x-wp-total")
			this.products = await result.json()

			let event = new CustomEvent("result-changed", {
				detail: { total: this.totalMatching },
				bubbles: true,
				composed: true,
			})
			this.querySelector("cf-filters").dispatchEvent(event)
			return result.data
		} catch (err) {
			this.totalMatching = 0
			console.error("Error fetching products:", err)
			this.message = "Ett fel uppstod vid hämtning av produkter."
			return []
		} finally {
			this.loading = false
		}
	}

	_addExcludedCategory(catId) {
		if (!this.excluded_categories.includes(catId)) {
			this.excluded_categories = [...this.excluded_categories, catId]
		}

		// remove page param from url
		const url = new URL(window.location.href)
		url.searchParams.delete("page")
		window.history.pushState({}, "", url.toString())
		this.page = 1
		this.getFilteredProducts()
	}

	_removeExcludedCategory(catId) {
		this.excluded_categories = this.excluded_categories.filter(
			id => id !== catId,
		)
		// remove page param from url
		const url = new URL(window.location.href)
		url.searchParams.delete("page")
		window.history.pushState({}, "", url.toString())
		this.page = 1
		this.getFilteredProducts()
	}

	renderCategoryButton(cat) {
		return html`<button
			class="
										category-button
										${this.excluded_categories.includes(cat.id) ? "excluded" : ""}"
			@click="${() => {
				if (this.excluded_categories.includes(cat.id)) {
					this._removeExcludedCategory(cat.id)
				} else {
					this._addExcludedCategory(cat.id)
				}
			}}">
			${unsafeHTML(cat.name)}
			${this.excluded_categories.includes(cat.id)
				? html`
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none">
							<path
								d="M6 12H18"
								stroke="#4B883C"
								stroke-width="1.5"
								stroke-linecap="round"
								stroke-linejoin="round" />
							<path
								d="M12 18V6"
								stroke="#4B883C"
								stroke-width="1.5"
								stroke-linecap="round"
								stroke-linejoin="round" />
						</svg>
					`
				: html`<svg
						xmlns="http://www.w3.org/2000/svg"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none">
						<path
							d="M6 12H18"
							stroke="#FAFAFA"
							stroke-width="1.5"
							stroke-linecap="round"
							stroke-linejoin="round" />
					</svg>`}
		</button>`
	}

	render() {
		return html`
			<div class="shop-container">
				<cf-filters></cf-filters>
			<div class="category-filter ">
								${
									this.categoriesOpen
										? this.categories.length > 3
											? html`
													<div class="category-list">
														${this.categories.map(cat =>
															this.renderCategoryButton(cat),
														)}
													</div>
													<button
														class="open-categories-btn"
														@click=${() => {
															this.categoriesOpen = false
														}}>
														Dölj kategorier
													</button>
												`
											: html``
										: this.categories.length > 0
											? html`<button
													class="open-categories-btn"
													@click=${() => {
														this.categoriesOpen = true
													}}>
													Visa kategorier
												</button>`
											: ``
								}
				</div>
				${
					(this.breadcrumbs.length > 1 &&
						html`<div class="breadcrumbs">
							${this.breadcrumbs.map(
								(crumb, index) =>
									html`<a href="${crumb.permalink}" class="breadcrumb-link"
											>${crumb.name}</a
										>${index < this.breadcrumbs.length - 1
											? html`<span class="breadcrumb-separator">/</span>`
											: ""}`,
							)}
						</div>`) ||
					""
				}
								</div>
					<div class="products-container">
						${
							this.loading
								? html`<div class="loading">${unsafeHTML(LOADING_SVG)}</div>`
								: this.products.length
									? this.products.map(
											product =>
												html`<product-listing
													.product=${product}></product-listing>`,
										)
									: html`<div class="no-products">Inga produkter hittades</div>`
						}
					</div>
				</div>

				${this.renderPagination()}
				<div class="shop-description">
					${unsafeHTML(this.description)}
				</div>

			</div>
		`
	}

	_goToPage(page) {
		this.page = page
		// update url without reloading
		const url = new URL(window.location.href)
		url.searchParams.set("page", page)
		window.history.pushState({}, "", url.toString())
		this.getFilteredProducts()
	}

	renderPagination() {
		const perPage = 12
		const total = Number(this.totalMatching || 0)
		if (total <= perPage) return html``

		const totalPages =
			total % perPage === 0 ? total / perPage : Math.floor(total / perPage) + 1
		this.total_pages = totalPages

		const maxButtons = 7
		let start = Math.max(1, this.page - Math.floor(maxButtons / 2))
		let end = Math.min(totalPages, start + maxButtons - 1)
		if (end - start + 1 < maxButtons) {
			start = Math.max(1, end - maxButtons + 1)
		}

		const pages = []
		for (let i = start; i <= end; i++) pages.push(i)

		return html`
			<nav class="cf-pagination" aria-label="Produkt pagination">
				<button
					class="nav-btn"
					@click="${() => this._goToPage(this.page - 1)}"
					?disabled="${this.page <= 1}">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="10"
						height="14"
						viewBox="0 0 10 14"
						fill="none">
						<path
							d="M5.00095 1.00012L2.37097 5.55537C1.93648 6.30792 1.94001 7.22461 2.36685 7.97718L5.00391 12.5454"
							stroke="#1C1E1D"
							stroke-width="1.45038"
							stroke-linecap="round"
							stroke-linejoin="round" />
					</svg>
				</button>

				${start > 1
					? html`<button class="nav-btn" @click="${() => this._goToPage(1)}">
								1
							</button>
							<span class="ellipsis" aria-hidden="true">…</span>`
					: ""}
				${pages.map(
					p =>
						html`<button
							class="${p === this.page ? "active" : ""} nav-btn"
							@click="${() => this._goToPage(p)}"
							aria-current="${p === this.page ? "page" : false}">
							${p}
						</button>`,
				)}
				${end < totalPages
					? html`<span class="ellipsis" aria-hidden="true">…</span>
							<button
								class="nav-btn"
								@click="${() => this._goToPage(totalPages)}">
								${totalPages}
							</button>`
					: ""}

				<button
					class="nav-btn"
					@click="${() => this._goToPage(this.page + 1)}"
					?disabled="${this.page >= totalPages}">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="10"
						height="14"
						viewBox="0 0 10 14"
						fill="none">
						<path
							d="M4.99906 12.5453L7.62903 7.99004C8.06352 7.23749 8.05999 6.3208 7.63315 5.56823L4.99609 1"
							stroke="#1C1E1D"
							stroke-width="1.45038"
							stroke-linecap="round"
							stroke-linejoin="round" />
					</svg>
				</button>
			</nav>
		`
	}
}
